import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { FaDownload } from "react-icons/fa";

const TechReviewerNewExport = ({
  jsonData,
  sheetNames,
  fileName,
  className,
  exportPosition,
  color,
  type,
}) => {
  console.log("json data", jsonData);
  // console.log("TechReviewerNewExport rendered with:", { jsonData, sheetNames, fileName }); // Debug log
  let version = jsonData?.auditDetails && jsonData?.auditDetails?.find(item => item.label === "Version")?.value;

  console.log("version", version);
  // Set default values
  jsonData = jsonData || {};
  sheetNames = sheetNames || [
    "Unit Details",
    "Audit details",
    "Protocol details",
    "Scoring details",
    "Areas of Concern",
    "PY-Areas of Concern",
    "FSSC Findings",
    "PY-FSSC Findings",
  ];
  fileName = fileName || "Report";
  className = className || "";
  color = color || "FF0000"; // Default red header
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const columnWidth = { wch: 20 };
  const unitDetailsCols = [
    { wch: 15 }, // Unit Type
    { wch: 25 }, // Manufacturing Code (3 Letter) (if applicable)
    { wch: 35 }, // Quality Manager or Lead Auditee
    { wch: 40 }, // Quality Manager or Lead Auditee Email
    { wch: 35 }, // Current Third Party Certifications Held
    { wch: 30 }, // Parent Unit Name
    { wch: 20 }, // Unit Country
    { wch: 20 }, // Unit Region
    { wch: 25 }, // CB Name
    { wch: 25 }, // Enterprise
    { wch: 30 }, // Responsible Segment
    { wch: 30 }, // Responsible Division
    { wch: 25 }, // Business Unit
    { wch: 30 }, // Sub Business Unit
    { wch: 30 }, // Off-Site Activities (if applicable)
    { wch: 30 }, // Type of Off-Site Activity
    { wch: 30 }, // Is Location Currently Audited?
    { wch: 30 }, // Site Name
    { wch: 35 }, // If Yes - Who is Auditing Location
  ];

  // Define column widths for both sheets
  const auditCols = [
    { wch: 25 }, // audit_criteria
    { wch: 20 }, // audit_delivery
    { wch: 15 }, // audit_start_date
    { wch: 15 }, // audit_end_date
    { wch: 15 }, // audit_language
    { wch: 15 }, // audit_type
    { wch: 20 }, // cb_office_location
    { wch: 10 }, // is_fssc_conjunction
    { wch: 15 }, // lead_auditor
    { wch: 10 }, // version
    { wch: 25 }, // focus_area
  ];

  const protocolCols = [
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 25 }, // focus_area
  ];

  const areasOfConcernsCols = [
    { wch: 15 }, // Number (#)
    { wch: 35 }, // Standard or Technical Specifications
    { wch: 25 }, // Requirement Reference
    { wch: 35 }, // Details of Nonconformity
    { wch: 30 }, // Evidence of Non-conformity
    { wch: 25 }, // Nonconformity Rating
    { wch: 25 }, // Nonconformance Status
    { wch: 30 }, // Corrective Action Evidence
  ];

  const fsscFindngCols = [
    { wch: 15 }, // Number (#)
    { wch: 35 }, // Standard or Technical Specifications
    { wch: 25 }, // Requirement Reference
    { wch: 35 }, // Details of Nonconformity
    { wch: 30 }, // Evidence of Non-conformity
    { wch: 25 }, // Nonconformity Rating
    { wch: 25 }, // NonConformance Status
    { wch: 30 }, // Evidence Of Correction
  ];

  const PYAreasOfConcernsCols = [
    { wch: 15 }, // Number (#)
    { wch: 35 }, // Standard or Technical Specifications
    { wch: 25 }, // Requirement Reference
    { wch: 35 }, // Details of Nonconformity
    { wch: 30 }, // Evidence of Non-conformity
    { wch: 25 }, // Nonconformity Rating
    { wch: 25 }, // NonConformance Status
    { wch: 30 }, // Evidence Of Correction
  ];
  const PYFSSCFindingsCols = [
    { wch: 15 }, // Number (#)
    { wch: 35 }, // Standard or Technical Specifications
    { wch: 25 }, // Requirement Reference
    { wch: 35 }, // Details of Nonconformity
    { wch: 30 }, // Evidence of Non-conformity
    { wch: 25 }, // Nonconformity Rating
    { wch: 25 }, // NonConformance Status
    { wch: 30 }, // Evidence Of Correction
  ];

  function formatDate(dateStr) {
    const date = new Date(dateStr);

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    // Return the formatted date
    return `${day}-${month}-${year}`;
  }

  // Apply styles to the sheet
  const addStyles = (workSheet, color) => {
    // Apply special styling to "Previous Year Non-conformity" heading and column headers
    // Find the row that contains "Previous Year Non-conformity" text
    let previousYearRow = null;
    let headingStartCol = null;
    let headingEndCol = null;
    
    Object.entries(workSheet)
      .filter(([k, v]) => v.v && typeof v.v === 'string' && v.v.includes("Previous Year Non-conformity"))
      .forEach(([k, v]) => {
        const match = k.match(/\d+/);
        const colMatch = k.match(/^([A-Z]+)/);
        if (match && match[0]) {
          const rowNumber = parseInt(match[0]);
          previousYearRow = rowNumber;
          headingStartCol = colMatch[1];
          
          // Style the "Previous Year Non-conformity" heading itself
          v.s = {
            fill: { fgColor: { rgb: "F1634D" } }, // Custom color for Previous Year heading
            alignment: { vertical: "center", horizontal: "center" },
            font: { bold: true, color: { rgb: "FFFFFF" } }, // White bold text
          };
        }
      });

    // Apply custom color to the row after "Previous Year Non-conformity" (which contains the column headers)
    if (previousYearRow) {
      const headerRow = previousYearRow + 2; // Skip one empty row after heading
      
      // Find the end column by looking at the header row
      Object.entries(workSheet)
        .filter(([k]) => {
          const match = k.match(/\d+/);
          if (match && match[0]) {
            const rowNumber = parseInt(match[0]);
            return rowNumber === headerRow;
          }
          return false;
        })
        .forEach(([k, v]) => {
          const colMatch = k.match(/^([A-Z]+)/);
          if (colMatch && colMatch[1]) {
            headingEndCol = colMatch[1];
          }
        });
      
      // Merge cells for the heading row
      if (headingStartCol && headingEndCol) {
        const mergeRange = `${headingStartCol}${previousYearRow}:${headingEndCol}${previousYearRow}`;
        if (!workSheet['!merges']) workSheet['!merges'] = [];
        workSheet['!merges'].push(XLSX.utils.decode_range(mergeRange));
      }
      
      Object.entries(workSheet)
        .filter(([k]) => {
          const match = k.match(/\d+/);
          if (match && match[0]) {
            const rowNumber = parseInt(match[0]);
            return rowNumber === headerRow;
          }
          return false;
        })
        .forEach(([k, v]) => {
          v.s = {
            fill: { fgColor: { rgb: "F1634D" } }, // Custom color for Previous Year headers
            alignment: { vertical: "center", horizontal: "center" },
            font: { bold: true, color: { rgb: "FFFFFF" } }, // White bold text
          };
        });
    }

    // Apply styles to the main header row (columns A-Z, AA, AB, etc.)
    Object.entries(workSheet)
      .filter(([k]) => k.match(/^[A-Z]{1,2}1$/)) // Target all header rows (1st row of each column, including multi-letter columns)
      .forEach(([k, v]) => {
        v.s = {
          fill: { fgColor: { rgb: color } }, // Header background color
          alignment: { vertical: "center", horizontal: "left" },
          font: { bold: true, color: { rgb: "FFFFFF" } }, // White text
        };
      });

    // Apply styles to the data rows (columns A-Z, AA, AB, etc.)
    Object.entries(workSheet)
      .filter(([k]) => k.match(/^[A-Z][2-9]\d*$/)) // Apply styles for other rows (excluding header row)
      .forEach(([k, v]) => {
        // Skip styling if this cell is part of the "Previous Year Non-conformity" heading or its column headers
        const match = k.match(/\d+/);
        if (match && match[0] && previousYearRow) {
          const rowNumber = parseInt(match[0]);
          if (rowNumber === previousYearRow || rowNumber === previousYearRow + 2) {
            return; // Skip styling for these rows as they're already styled above
          }
        }
        
        v.s = {
          alignment: { vertical: "center", horizontal: "left", wrapText: true },
        };
      });

    // Set the same column width for all columns
    // Note: Column widths are now set individually per sheet type
    // This section is removed to allow custom column widths per sheet
  };

  const exportToExcel = () => {
    // console.log("Export clicked, jsonData:", jsonData); // Debug log
    
    if (!jsonData || Object.keys(jsonData).length === 0) {
      alert("No data to export"); // Show alert if no data is present
      return;
    }

    // Format Unit Details Data
    const formattedUnitDetails = {};
    
    // Add unit details
    if (jsonData.unitDetails?.unitDetails) {
      jsonData.unitDetails.unitDetails.forEach((item) => {
        formattedUnitDetails[item.label] = item.value || "N/A";
      });
    }
    
    // Add off-site fields
    if (jsonData.unitDetails?.offSiteFields) {
      jsonData.unitDetails.offSiteFields.forEach((item) => {
        formattedUnitDetails[item.label] = item.value || "N/A";
      });
    }

    // If no unit details found, create a basic structure
    if (Object.keys(formattedUnitDetails).length === 0) {
      formattedUnitDetails["No Unit Details Available"] = "N/A";
    }

    // Format Audit Details Data
    console.log("Audit Details data:", jsonData.auditDetails); // Debug log
    
    // Check if auditDetails is an array (transformed data) or object (raw data)
    let auditFormattedData;
    
    if (Array.isArray(jsonData.auditDetails)) {
      // If it's an array (transformed data), convert to object format
      const auditObj = {};
      jsonData.auditDetails.forEach(item => {
        // Only add "Correction Date" if it has a valid value
        if (item.label === "Correction Date") {
          if(version !== 1){
            if (item.value && item.value !== "N/A") {
              auditObj[item.label] = item.value;
            }
          }
          
        } else {
          auditObj[item.label] = item.value || "N/A";
        }
      });
      auditFormattedData = [auditObj];
    } else {
      // If it's an object (raw data), use the original mapping
      const auditData = {
        "Audit Criteria": Array.isArray(jsonData.auditDetails?.audit_criteria)
          ? jsonData.auditDetails.audit_criteria.join(", ")
          : jsonData.auditDetails?.audit_criteria || "N/A",
        "Audit Delivery": jsonData.auditDetails?.audit_delivery || "N/A",
        "Audit Start Date": jsonData.auditDetails?.audit_start_date
          ? formatDate(jsonData.auditDetails.audit_start_date)
          : "N/A",
        "Audit End Date": jsonData.auditDetails?.audit_end_date
          ? formatDate(jsonData.auditDetails.audit_end_date)
          : "N/A",
        "Audit Language": jsonData.auditDetails?.audit_language || "N/A",
        "Audit Type":
          jsonData.auditDetails?.audit_type === "sustaining"
            ? "Sustaining"
            : jsonData.auditDetails?.audit_type === "gap assessment"
            ? "Gap Assesment"
            : "N/A",
        "CB Office Location": jsonData.auditDetails?.cb_office_location || "N/A",
        "Job Number": jsonData.auditDetails?.jobnumber || "N/A",
        "Is FSSC Conjunction":
          jsonData.auditDetails?.is_fssc_conjunction === true
            ? "Yes"
            : jsonData.auditDetails?.is_fssc_conjunction === false
            ? "No"
            : "N/A",
        "Lead Auditor": jsonData.auditDetails?.lead_auditor || "N/A",
        Version: jsonData.auditDetails?.version || "N/A",
        "Focus Area": Array.isArray(jsonData.auditDetails?.audit_focus_area)
          ? jsonData.auditDetails.audit_focus_area.join(", ")
          : "N/A",
      };

      // Only add "Correction Date" if it has a valid value
      if (jsonData.auditDetails && jsonData.auditDetails?.find(item => item.label === "Correction Date")?.value && jsonData.auditDetails?.find(item => item.label === "Correction Date")?.value !== "N/A") {
        auditData["Correction Date"] = jsonData.auditDetails?.find(item => item.label === "Correction Date")?.value;
      }

      auditFormattedData = [auditData];
    }

    // Format Protocol Details Data
    const protocolEntries = {};
    
    // Add dynamic protocol questions from protocolList
    if (jsonData.protocolDetails?.protocolList?.protocolFindings) {
      jsonData.protocolDetails.protocolList.protocolFindings.forEach((section) => {
        section.subsection.forEach((subsection) => {
          subsection.questions.forEach((question) => {
            // Create a key that combines section, subsection, and question text
            const key = `${section.section} - ${subsection.subSectionName} - ${question.text}`;
            protocolEntries[key] = question.answer || "N/A";
          });
        });
      });
    }

    // Add focus area entries
    const focusAreaEntries = Object.entries(jsonData.protocolDetails?.focusArea || {})
      .map(([key, value]) => `${key}: ${value}`)
      .join(", ");

    const protocolFormattedData = [
      {
        ...protocolEntries,
        "Focus Area": focusAreaEntries || "N/A",
      },
    ];

    // Format Scoring Details Data
    const scoringFormattedData = [
      {
        "Area Opportunity":
          jsonData.scoringDetails?.auditConclusion?.areaOpportunity || "N/A",
        "Area Strength": jsonData.scoringDetails?.auditConclusion?.areaStrength || "N/A",
        "Zero Finding Justification":
          jsonData.scoringDetails?.auditConclusion?.zeroFindingJustification || "N/A",
        "Audit Duration (Hours)":
          jsonData.scoringDetails?.auditConclusion?.auditDurationHour === 0
            ? "0"
            : jsonData.scoringDetails?.auditConclusion?.auditDurationHour
            ? jsonData.scoringDetails.auditConclusion.auditDurationHour
            : "N/A",
        "Audit Duration (Minutes)":
          jsonData.scoringDetails?.auditConclusion?.auditDurationMinutes === 0
            ? "0"
            : jsonData.scoringDetails?.auditConclusion?.auditDurationMinutes
            ? jsonData.scoringDetails.auditConclusion.auditDurationMinutes
            : "N/A",
        "Conformance Level":
          jsonData.scoringDetails?.auditConclusion?.conformanceLevel || "N/A",
        "FSSC Certification Recommended": 
          jsonData.scoringDetails?.auditConclusion?.isFfscCertificationRecommended === 1
            ? "Yes"
            : jsonData.scoringDetails?.auditConclusion?.isFfscCertificationRecommended === 0
            ? "No"
            : "N/A",
        "Critical (FSSC)":
          jsonData.scoringDetails?.fsscScore?.[0]?.critical !== false
            ? jsonData.scoringDetails.fsscScore[0].critical
            : "N/A",
        "Major (FSSC)":
          jsonData.scoringDetails?.fsscScore?.[0]?.major !== false
            ? jsonData.scoringDetails.fsscScore[0].major
            : "N/A",
        "Minor (FSSC)":
          jsonData.scoringDetails?.fsscScore?.[0]?.minor !== false
            ? jsonData.scoringDetails.fsscScore[0].minor
            : "N/A",
        "Critical (QMS)":
          jsonData.scoringDetails?.qmsScore?.[0]?.critical !== false
            ? jsonData.scoringDetails.qmsScore[0].critical
            : "N/A",
        "Major (QMS)":
          jsonData.scoringDetails?.qmsScore?.[0]?.major !== false
            ? jsonData.scoringDetails.qmsScore[0].major
            : "N/A",
        "Minor (QMS)":
          jsonData.scoringDetails?.qmsScore?.[0]?.minor !== false
            ? jsonData.scoringDetails.qmsScore[0].minor
            : "N/A",

            "Non Conformance Score":
            jsonData.scoringDetails?.auditConclusion?.totalNonConformanceScore || "N/A",
      },
    ];

    // Format Areas of Concern Data
    // console.log("Areas of Concern data:", jsonData.protocolDetails?.areasOfConcern); // Debug log
    
    const currentYearAreasOfConcern = jsonData.protocolDetails?.areasOfConcern?.filter(item => item.isPreviousYear === false) || [];
    const previousYearAreasOfConcern = jsonData.protocolDetails?.areasOfConcern?.filter(item => item.isPreviousYear === true) || [];
    
    // console.log("Current year Areas of Concern:", currentYearAreasOfConcern); // Debug log
    // console.log("Previous year Areas of Concern:", previousYearAreasOfConcern); // Debug log

    let currentYearAreasOfConcernData;

    if(version !== 1){
      currentYearAreasOfConcernData = currentYearAreasOfConcern.map((item) => ({
        "Number (#)": item.number || "N/A",
        "Standard or Technical Specifications": item.standardOrTechnicalSpecification || "N/A",
        "Requirement Reference": item.RequirementReference || "N/A",
        "Details of Nonconformity": item.detailsOfNonconformity || "N/A",
        "Evidence of Non-conformity": item.evidenceOfNonconformity || "N/A",
        "Nonconformity Rating": item.nonconformityRating || "N/A",
        "Nonconformance Status": item.nonConformanceStatus || "N/A",
        "Corrective Action Evidence": item.evidenceOfCorrection || "N/A",
      }));
    }else{
      currentYearAreasOfConcernData = currentYearAreasOfConcern.map((item) => ({
        "Number (#)": item.number || "N/A",
        "Standard or Technical Specifications": item.standardOrTechnicalSpecification || "N/A",
        "Requirement Reference": item.RequirementReference || "N/A",
        "Details of Nonconformity": item.detailsOfNonconformity || "N/A",
        "Evidence of Non-conformity": item.evidenceOfNonconformity || "N/A",
        "Nonconformity Rating": item.nonconformityRating || "N/A",
        "Nonconformance Status": item.nonConformanceStatus || "N/A",
      }));
    }
    


    const previousYearAreasOfConcernData = previousYearAreasOfConcern.map((item) => ({
      "Number (#)": item.number || "N/A",
      "Standard or Technical Specifications": item.standardOrTechnicalSpecification || "N/A",
      "Requirement Reference": item.RequirementReference || "N/A",
      "Details of Nonconformity": item.detailsOfNonconformity || "N/A",
      "Evidence of Non-conformity": item.evidenceOfNonconformity || "N/A",
      "Nonconformity Rating": item.nonconformityRating || "N/A",
      "Nonconformance Status": item.nonConformanceStatus || "N/A",
      "Corrective Action Evidence": item.evidenceOfCorrection || "N/A",
    }));



    const areasOfConcernFormattedData = [...currentYearAreasOfConcernData];
    const PYAreasOfConcernFormattedData = [...previousYearAreasOfConcernData];
    
    
    // If no Areas of Concern data, add a placeholder
    // if (areasOfConcernFormattedData.length === 0) {
    //   areasOfConcernFormattedData.push({
    //     "Number (#)": "N/A",
    //     "Standard or Technical Specifications": "N/A",
    //     "Requirement Reference": "N/A",
    //     "Details of Nonconformity": "N/A",
    //     "Evidence of Non-conformity": "N/A",
    //     "Nonconformity Rating": "N/A",
    //     "Nonconformance Status": "N/A",
    //   });
    // }

    // Format FSSC Findings Data
    // console.log("FSSC Findings data:", jsonData.protocolDetails?.fsscFindings); // Debug log
    
    const currentYearFssc = jsonData.protocolDetails?.fsscFindings?.filter(item => item["Is Previous Year"] === false) || [];
    const previousYearFssc = jsonData.protocolDetails?.fsscFindings?.filter(item => item["Is Previous Year"] === true) || [];
    
    // console.log("Current year FSSC:", currentYearFssc); // Debug log
    // console.log("Previous year FSSC:", previousYearFssc); // Debug log

    let currentYearFsscData;

    if(version !== 1){
      currentYearFsscData = currentYearFssc.map((item) => ({
        "Number (#)": item["Number (#)"] || "N/A",
        "Standard or Technical Specifications": item["Standard or Technical Specifications"] || "N/A",
        "Requirement Reference ": item["Requirement Reference"] || "N/A",
        "Details of Nonconformity": item["Details of Nonconformity"] || "N/A",
        "Evidence of Non-conformity": item["Evidence of Non-conformity"] || "N/A",
        "Nonconformity Rating": item["Nonconformity Rating"] || "N/A",
        "NonConformance Status": item["NonConformance Status"] || "N/A",
        "Corrective Action Evidence": item["Evidence Of Correction"] || "N/A",
      }));
    }else{
      currentYearFsscData = currentYearFssc.map((item) => ({
        "Number (#)": item["Number (#)"] || "N/A",
        "Standard or Technical Specifications": item["Standard or Technical Specifications"] || "N/A",
        "Requirement Reference ": item["Requirement Reference"] || "N/A",
        "Details of Nonconformity": item["Details of Nonconformity"] || "N/A",
        "Evidence of Non-conformity": item["Evidence of Non-conformity"] || "N/A",
        "Nonconformity Rating": item["Nonconformity Rating"] || "N/A",
        "NonConformance Status": item["NonConformance Status"] || "N/A",
      }));
    }

    const previousYearFsscData = previousYearFssc.map((item) => ({
      "Number (#)": item["Number (#)"] || "N/A",
      "Standard or Technical Specifications":
        item["Standard or Technical Specifications"] || "N/A",
      "Requirement Reference ": item["Requirement Reference"] || "N/A",
      "Details of Nonconformity": item["Details of Nonconformity"] || "N/A",
      "Evidence of Non-conformity":
        item["Evidence of Non-conformity"] || "N/A",
      "Nonconformity Rating": item["Nonconformity Rating"] || "N/A",
      "NonConformance Status": item["NonConformance Status"] || "N/A",
      "Corrective Action Evidence": item["Evidence Of Correction"] || "N/A",
    }));



    const fsscFindingsFormattedData = [...currentYearFsscData];
    const PYFsscFindingsFormattedData = [...previousYearFsscData];
    
    // If no FSSC findings data, add a placeholder
    // if (fsscFindingsFormattedData.length === 0) {
    //   fsscFindingsFormattedData.push({
    //     "Number (#)": "No FSSC Findings Data Available",
    //     "Standard or Technical Specifications": "N/A",
    //     "Requirement Reference ": "N/A",
    //     "Details of Nonconformity": "N/A",
    //     "Evidence of Non-conformity": "N/A",
    //     "Nonconformity Rating": "N/A",
    //     "NonConformance Status": "N/A",
    //   });
    // }

    // Create worksheets for all sheets
    const unitDetailSheet = XLSX.utils.json_to_sheet([formattedUnitDetails]);
    const auditSheet = XLSX.utils.json_to_sheet(auditFormattedData);
    const protocolSheet = XLSX.utils.json_to_sheet(protocolFormattedData);
    const scoringSheet = XLSX.utils.json_to_sheet(scoringFormattedData);
    const areasOfConcernSheet = XLSX.utils.json_to_sheet(
      areasOfConcernFormattedData
    );
    const fsscFindingsSheet = XLSX.utils.json_to_sheet(
      fsscFindingsFormattedData
    );
    const PYAreasOfConcernSheet = XLSX.utils.json_to_sheet(
      PYAreasOfConcernFormattedData
    );
    const PYFsscFindingsSheet = XLSX.utils.json_to_sheet(
      PYFsscFindingsFormattedData
    );

    // Set column widths
    unitDetailSheet["!cols"] = unitDetailsCols;
    auditSheet["!cols"] = auditCols;
    protocolSheet["!cols"] = protocolCols;
    areasOfConcernSheet["!cols"] = areasOfConcernsCols;
    fsscFindingsSheet["!cols"] = fsscFindngCols;
    PYAreasOfConcernSheet["!cols"] = PYAreasOfConcernsCols;
    PYFsscFindingsSheet["!cols"] = PYFSSCFindingsCols;

    // Add styles to sheets
    addStyles(unitDetailSheet, color);
    addStyles(auditSheet, color);
    addStyles(protocolSheet, color);
    addStyles(scoringSheet, color);
    addStyles(areasOfConcernSheet, color);
    addStyles(fsscFindingsSheet, color);
    addStyles(PYAreasOfConcernSheet, color);
    addStyles(PYFsscFindingsSheet, color);
    // Create the workbook with all sheets
    const wb = {
      Sheets: {
        [sheetNames[0]]: unitDetailSheet,
        [sheetNames[1]]: auditSheet, // Audit details
        [sheetNames[2]]: protocolSheet, // Protocol details
        [sheetNames[3]]: scoringSheet, // Scoring details
        [sheetNames[4]]: areasOfConcernSheet, // Area Of concerns
        [sheetNames[5]]: PYAreasOfConcernSheet, // PY Area Of concerns
        [sheetNames[6]]: fsscFindingsSheet, // fssc finding sheet
        [sheetNames[7]]: PYFsscFindingsSheet, // PY fssc finding sheet
      },
      SheetNames: [
        sheetNames[0],
        sheetNames[1],
        sheetNames[2],
        sheetNames[3],
        sheetNames[4],
        sheetNames[5],
        sheetNames[6],
        sheetNames[7],
      ],
    };

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });

    // Optional: Add timestamp to the filename
    const timestamp = new Date().toISOString().split("T")[0]; // For example: 2025-03-08
    FileSaver.saveAs(data, `${fileName}-${timestamp}${fileExtension}`);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
        position: "relative",
        padding: "8px 12px",
        // backgroundColor: "#ffffff",
        // border: "1px solid #ff8200",
        // borderRadius: "4px",
        // boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        zIndex: 1000,
        minWidth: "120px",
      }}
      title="Export in Excel"
      onClick={exportToExcel}
      className={`${className} bg-orange-500 text-white px-4 py-2 rounded-md hover:bg-orange-600 transition duration-300` }
    >
      <FaDownload color="#ffffff" size={18} />
      <p
        style={{
          marginBottom: "0",
          // color: "#ff8200",
          fontSize: "18px",
          fontWeight: "500",
        }}
      >
        Export Data
      </p>
    </div>
  );
};

export default TechReviewerNewExport;

